import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getClients } from "../api";
import "../styles/insuranceClients.css";

const PoliciesByInsurer = () => {
  const [clients, setClients] = useState([]);
  const [selectedInsurer, setSelectedInsurer] = useState("");
  const navigate = useNavigate();

  // ✅ Fetch all clients on mount
  useEffect(() => {
    const fetchClients = async () => {
      const data = await getClients();
      setClients(data);
    };
    fetchClients();
  }, []);

  // ✅ Get unique insurer names dynamically
  const insurers = [...new Set(clients.map((c) => c.insurer).filter(Boolean))];

  // ✅ Filter by selected insurer
  const filtered = selectedInsurer
    ? clients.filter(
        (c) => c.insurer && c.insurer.toLowerCase() === selectedInsurer.toLowerCase()
      )
    : clients;

  // ✅ Format readable date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const d = new Date(dateString);
    if (isNaN(d.getTime())) return "N/A";
    return d.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <div className="insurance-clients">
      {/* 🔙 Back + Title */}
      <div className="page-header">
        <button className="back-btn" onClick={() => navigate("/insurance")}>
          ← Back to Insurance
        </button>
        <h2 className="page-title">Policies by Insurer</h2>
      </div>

      {/* 🧾 Filter Dropdown */}
      <div className="insurer-filter">
        <label htmlFor="insurer">Select Insurer:</label>
        <select
          id="insurer"
          value={selectedInsurer}
          onChange={(e) => setSelectedInsurer(e.target.value)}
        >
          <option value="">All Insurers</option>
          {insurers.map((name, index) => (
            <option key={index} value={name}>
              {name}
            </option>
          ))}
        </select>
      </div>

      {/* 📋 Table */}
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Client Name</th>
              <th>Premium Paid</th>
              <th>Paid to Apex</th>
              <th>Payment Number</th>
              <th>Vehicle Number</th>
              <th>Policy Number</th>
              <th>Premium</th>
              <th>Insurer</th>
              <th>Date of Next Renewal</th>
              <th>Policy Type</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr>
                <td colSpan="10" className="no-data">
                  No policies found for this insurer.
                </td>
              </tr>
            ) : (
              filtered.map((c, i) => (
                <tr key={i}>
                  <td>{c.name}</td>
                  <td>{c.premium_paid}</td>
                  <td>{c.paid_to_apex}</td>
                  <td>{c.payment_number}</td>
                  <td>{c.vehicle_number}</td>
                  <td>{c.policy_number}</td>
                  <td>{c.premium}</td>
                  <td>{c.insurer}</td>
                  <td>{formatDate(c.renewal_date)}</td>
                  <td>{c.policy_type}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PoliciesByInsurer;
